import { t } from "i18next";
import Swal from "sweetalert2";
import colors from "../../../utils/colors";
import { toast } from "react-toastify";

const SwalAlert = {
    confirm: (title, text, onConfirm, onCancel) => {
        Swal.fire({
            title: title || "Are you sure?",
            text: text || "You won't be able to revert this!",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: colors.confirmMessage,
            cancelButtonColor: colors.cancel,
            confirmButtonText: t('confirm'),
            cancelButtonText: t('cancel'),
        }).then((result) => {
            if (result.isConfirmed) {
                onConfirm && onConfirm(result.value);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                onCancel && onCancel();
            }
        });
    },
    confirmInput: (title, text, showInput = false, onConfirm, onCancel) => {
        Swal.fire(showInput ? {
            title: title || "Are you sure?",
            text: text || "You won't be able to revert this!",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: colors.confirmMessage,
            cancelButtonColor: colors.cancel,
            confirmButtonText: t('confirm'),
            cancelButtonText: t('cancel'),
            input: 'text',
            inputPlaceholder: t('doNotAskAgain'),
        } : {
            title: title || "Are you sure?",
            text: text || "You won't be able to revert this!",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: colors.confirmMessage,
            cancelButtonColor: colors.cancel,
            confirmButtonText: t('confirm'),
            cancelButtonText: t('cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                onConfirm && onConfirm(result.value);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                onCancel && onCancel();
            }
        });
    },

    success: (title, onConfirm) => {
        Swal.fire({
            title: title || "Success!",
            icon: "success",
            confirmButtonColor: colors.confirmMessage,
            confirmButtonText: t('close'),
        }).then((result) => {
            if (result.isConfirmed) {
                onConfirm && onConfirm();
            }
        });
    },

    error: (title, text, onConfirm, allowOutsideClick = true) => {
        Swal.fire({
            allowOutsideClick: allowOutsideClick,
            title: title || "Error!",
            text: text || "Something went wrong.",
            icon: "error",
            confirmButtonColor: "#d33",
            confirmButtonText: t('close'),
        }).then((result) => {
            if (result.isConfirmed) {
                onConfirm && onConfirm();
            }
        });
    },
    successMSG: (title) => {
        toast.success(title, {
            position: "top-left"
        })
    },
    successError: (title) => {
        toast.error(title, {
            position: "top-left"
        })
    },

};

export default SwalAlert;
